import isNumber from 'lodash/isNumber';

import {
  getDiscountDataFromSellingPlan,
  getDiscountFromSellingPriceAdjustment,
  getDiscountQuantityFromParam,
  isGlobalProduct,
} from '../../utils';

export function getDiscountFromUrl(price: number): number {
  const urlParams = new URLSearchParams(window?.location.search);
  const discountParam = urlParams.get('d') || '';
  const discount = getDiscountQuantityFromParam(discountParam, price);

  return discount;
}

export function getDiscountFromSellingPlan(
  product: { selling_plan_groups: SellingPlanGroup[] } | LiquidProduct,
  price: number,
  sellingPlan: string | number,
):
  | number
  | {
      type: string;
      value: number;
    } {
  if (product) {
    const discountData = getDiscountDataFromSellingPlan(product, sellingPlan);

    const discount = getDiscountFromSellingPriceAdjustment(price, discountData);

    if (isNumber(discount)) {
      return Math.round(discount * 100) / 100;
    } else {
      return discount;
    }
  }

  return 0;
}

export const getItemPropertiesFromState =
  (
    baseProperties: BundleCartProperties,
    selectedProducts: Record<string, number>,
    productsInCollection: GlobalVariant[] | GlobalProduct[],
  ): (() => BundleCartProperties) =>
  () => {
    const selectedProductNameAndQuantity = (
      productsInCollection as any[]
    ).reduce((acc, product) => {
      let variant;
      if (isGlobalProduct(product)) {
        variant = product.variants.find(({ id }) => {
          return !!Object.keys(selectedProducts).find((key) => key === `${id}`);
        });
      } else variant = product;
      const selectedProductCount = selectedProducts[variant?.id];
      if (selectedProductCount) {
        const name = variant.name.replace(/[&]/gi, 'and');
        return {
          ...acc,
          [`_pv_${variant.id}`]: selectedProductCount,
          [name]: `${selectedProductCount}`,
        };
      }
      return acc;
    }, {});

    const sortedSelectProperties = sortObjectProperties(
      selectedProductNameAndQuantity,
    );

    return { ...baseProperties, ...sortedSelectProperties };
  };

const sortObjectProperties = <T extends Record<string, string>>(
  object: T,
): T => {
  const sortedObject = {};
  const keys = Object.keys(object);
  keys.sort((a, b) => (a.toUpperCase() < b.toUpperCase() ? -1 : 1));
  keys.forEach((key) => {
    sortedObject[key] = object[key];
  });
  return sortedObject as T;
};
